import { z } from 'zod';

import { SearchResultAdvisorZod } from 'types/zod/search-result-advisor';
import { SearchResultClientZod } from 'types/zod/search-result-client';
import { SearchResultGroupZod } from 'types/zod/search-result-group';

export const SearchResultZod = z.object({
    advisors: z.array(SearchResultAdvisorZod).nullable().optional(),
    groups: z.array(SearchResultGroupZod).nullable().optional(),
    clients: z.array(SearchResultClientZod).nullable().optional(),
});
export type SearchResult = z.infer<typeof SearchResultZod>;
